import React from 'react';
import P1 from '../../assets/img/certifications/latest/wwcc.svg';
import P2 from '../../assets/img/certifications/latest/insurance.svg';
import P3 from '../../assets/img/certifications/latest/plumbing.svg';
import P4 from '../../assets/img/certifications/latest/buildcontractor.svg';
import P5 from '../../assets/img/certifications/latest/asbestos.svg';
import Paragraph from '../../components/common/Typography/Paragraph';

export const Badges = () => {
  return (
    <div className="flex flex-col gap-5 items-start">
      {/* <a
        href="#"
        className="flex flex-row items-center gap-3 group transition-colors duration-200"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={P1} alt="Children Check Badge" className="w-[50px] h-[50px] object-contain" />
        <Paragraph variant={"BodyCompact"} className="group-hover:text-primaryblue transition-colors duration-200">WWCC</Paragraph>
      </a> */}
      <a
        href="#"
        className="flex flex-row items-center gap-3 group transition-colors duration-200"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={P2} alt="Insurance Badge" className="w-[50px] h-[50px] object-contain" />
        <Paragraph variant={"BodyCompact"} className="group-hover:text-primaryblue transition-colors duration-200">Insurance</Paragraph>
      </a>
      <a
        href="#"
        className="flex flex-row items-center gap-3 group transition-colors duration-200"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={P3} alt="Plumber Badge" className="w-[50px] h-[50px] object-contain" />
        <Paragraph variant={"BodyCompact"} className="group-hover:text-primaryblue transition-colors duration-200">Plumber</Paragraph>
      </a>
      <a
        href="#"
        className="flex flex-row items-center gap-3 group transition-colors duration-200"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={P4} alt="Building Contractor Badge" className="w-[50px] h-[50px] object-contain" />
        <Paragraph variant={"BodyCompact"} className="group-hover:text-primaryblue transition-colors duration-200">Building Contractor</Paragraph>
      </a>
      {/* <a
        href="#"
        className="flex flex-row items-center gap-3 group transition-colors duration-200"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={P5} alt="Asbestos Badge" className="w-[50px] h-[50px] object-contain" />
        <Paragraph variant={"BodyCompact"} className="group-hover:text-primaryblue transition-colors duration-200">Asbestos</Paragraph>
      </a> */}
    </div>
  );
}; 